import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mac'
})
export class MacPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value ? value.replace(/:/g, '') : null;
  }

}
